export default "__VITE_ASSET__DDUw5RF$__ 640w, __VITE_ASSET__CEo4EQrQ__ 1024w, __VITE_ASSET__BK7IusbM__ 1920w";